import { action, observable, makeObservable } from 'mobx';
import { exchangeAmountByRate } from '@pascal/pascal-core';

class LiveBetsDataStore {
  liveBets = [];

  constructor() {
    makeObservable(this, {
      liveBets: observable.deep,
      setLiveBets: action.bound,
      updateLiveBets: action.bound,
      resetLiveBetsData: action.bound,
    });
  }

  setLiveBets(liveBets) {
    this.liveBets = liveBets.map((liveBet) => ({
      id: liveBet.id,
      odd: liveBet.odd,
      userId: liveBet.userId,
      freeBetId: liveBet.freeBetId,
      ...exchangeAmountByRate(liveBet),
    }));
  }

  updateLiveBets(liveBet) {
    const result = {
      id: liveBet.id,
      odd: liveBet.odd,
      userId: liveBet.userId,
      freeBetId: liveBet.freeBetId,
      ...exchangeAmountByRate(liveBet),
    };
    if (this.liveBets.length === 30) {
      this.liveBets = [result, ...this.liveBets];
      this.liveBets.pop();
    } else {
      this.liveBets = [result, ...this.liveBets];
    }
  }

  resetLiveBetsData(data) {
    this.liveBets = data;
  }
}

export const liveBetsDataStore = new LiveBetsDataStore();
